var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2"},[_c('back-to-dashboard'),_c('div',{staticClass:"mt-3"},[_c('creator-guide')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }